module.exports = __webpack_public_path__ + "img/IT0000641229480.7a6ab39e.png";